import { render, staticRenderFns } from "./test.vue?vue&type=template&id=6a320363&"
import script from "./test.vue?vue&type=script&lang=js&"
export * from "./test.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a320363')) {
      api.createRecord('6a320363', component.options)
    } else {
      api.reload('6a320363', component.options)
    }
    module.hot.accept("./test.vue?vue&type=template&id=6a320363&", function () {
      api.rerender('6a320363', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/alf/gehad/test.vue"
export default component.exports